import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { P } from '../theme/tokens';

const Box = styled.span`
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: ${(p) => (p.$dashed ? P.subtle : p.$color ? p.$text : P.white)};
  background: ${(p) => (p.$dashed ? P.white : p.$color || P.grad)};
  border: ${(p) => (p.$dashed ? `1px dashed ${P.border}` : 'none')};
  font-size: ${(p) => Math.round(p.$size * 0.34)}px;
  font-weight: 700;
`;

const initialsOf = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '';
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
};

export const noLetters = (name) => Boolean(name) && !/\p{L}/u.test(String(name));

export default function Avatar({ name, icon = noLetters(name) ? faUser : undefined, size = 36, color, text, dashed }) {
  return (
    <Box $size={size} $color={color} $text={text} $dashed={dashed} aria-hidden="true">
      {icon ? <FontAwesomeIcon icon={icon} /> : initialsOf(name)}
    </Box>
  );
}
